// extracted by mini-css-extract-plugin
export default {"panel":"BlocksPanel_panel__1skWj","grid":"BlocksPanel_grid__y0beY","kind":"BlocksPanel_kind__pe834","templates":"BlocksPanel_templates__+UCr5"};